// Shared by public downloads, server-rendered copy, and support documentation.
const APP_STORE_URL = 'https://apps.apple.com/us/app/gab-ai/id6759009193';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=ai.gab.gabaiapp';
const MICROSOFT_STORE_URL = 'https://apps.microsoft.com/detail/9nbmwtz69fgk';

module.exports = { APP_STORE_URL, GOOGLE_PLAY_URL, MICROSOFT_STORE_URL };
